import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularMaterialModule } from 'src/app/angular-material/angular-material.module';
import { ReactiveFormsModule } from '@angular/forms';
import { PatientManagerComponent } from './sections/patient-manager/patient-manager.component';
import { PatientManagerTableComponent } from './sections/patient-manager-table/patient-manager-table.component';
import { TransferPatientDialogComponent } from './dialogs/transfer-patient-dialog/transfer-patient-dialog.component';
import { DeletePatientDialogComponent } from './dialogs/delete-patient-dialog/delete-patient-dialog.component';
import { ResetPasswordDialogComponent } from './dialogs/reset-password-dialog/reset-password-dialog.component';
import { ReviewTransferPatientDialogComponent } from './dialogs/review-transfer-patient-dialog/review-transfer-patient-dialog.component';
import { GenerateCodesCSVDialogComponent } from './dialogs/generate-codes-csv-dialog/generate-codes-csv-dialog.component';



@NgModule({
  declarations: [
    PatientManagerComponent,
    PatientManagerTableComponent,
    TransferPatientDialogComponent,
    DeletePatientDialogComponent,
    ResetPasswordDialogComponent,
    ReviewTransferPatientDialogComponent,
    GenerateCodesCSVDialogComponent
  ],
  imports: [
    CommonModule,
    AngularMaterialModule,
    ReactiveFormsModule,

  ],
  exports: [
    PatientManagerComponent,
    PatientManagerTableComponent
  ],
})
export class PatientManagerModule { }
